import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { JURNI_CORE_REQUIRED_INFO } from "@/constants/getting-started";

export const JurniCoreInfo = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        aria-label="Important: why Jurni Core is required"
        onClick={(event) => event.stopPropagation()}
        className="inline-flex shrink-0 items-center justify-center rounded-full text-red-600 hover:text-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info className="size-3.5" />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-64 text-xs">
      <p>{JURNI_CORE_REQUIRED_INFO}</p>
    </TooltipContent>
  </Tooltip>
);
